var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 35,
    viewBox: "0 0 113 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.69159,
    cy: 17.0483,
    r: 1.90324,
    transform: "rotate(-45 2.69159 17.0483)",
    fill: "#0086FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.28144,
    cy: 20.6372,
    r: 1.90324,
    transform: "rotate(-45 6.28144 20.6372)",
    fill: "#0086FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.86737,
    cy: 24.2261,
    r: 1.90324,
    transform: "rotate(-45 9.86737 24.2261)",
    fill: "#0086FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4611,
    cy: 27.8149,
    r: 1.90324,
    transform: "rotate(-45 13.4611 27.8149)",
    fill: "#0086FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0471,
    cy: 31.4038,
    r: 1.90324,
    transform: "rotate(-45 17.0471 31.4038)",
    fill: "#0086FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.28144,
    cy: 13.4595,
    r: 1.90324,
    transform: "rotate(-45 6.28144 13.4595)",
    fill: "#0086FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.86737,
    cy: 17.0483,
    r: 1.90324,
    transform: "rotate(-45 9.86737 17.0483)",
    fill: "#0086FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4572,
    cy: 20.6372,
    r: 1.90324,
    transform: "rotate(-45 13.4572 20.6372)",
    fill: "#0086FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0471,
    cy: 24.2261,
    r: 1.90324,
    transform: "rotate(-45 17.0471 24.2261)",
    fill: "#0086FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6369,
    cy: 27.8149,
    r: 1.90324,
    transform: "rotate(-45 20.6369 27.8149)",
    fill: "#0086FF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.86737,
    cy: 9.87061,
    r: 1.90324,
    transform: "rotate(-45 9.86737 9.87061)",
    fill: "#0086FF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4572,
    cy: 13.4595,
    r: 1.90324,
    transform: "rotate(-45 13.4572 13.4595)",
    fill: "#0086FF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0471,
    cy: 17.0483,
    r: 1.90324,
    transform: "rotate(-45 17.0471 17.0483)",
    fill: "#0086FF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6369,
    cy: 20.6372,
    r: 1.90324,
    transform: "rotate(-45 20.6369 20.6372)",
    fill: "#0086FF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2228,
    cy: 24.2261,
    r: 1.90324,
    transform: "rotate(-45 24.2228 24.2261)",
    fill: "#0086FF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4611,
    cy: 6.28223,
    r: 1.90324,
    transform: "rotate(-45 13.4611 6.28223)",
    fill: "#0086FF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0471,
    cy: 9.87061,
    r: 1.90324,
    transform: "rotate(-45 17.0471 9.87061)",
    fill: "#0086FF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6369,
    cy: 13.4595,
    r: 1.90324,
    transform: "rotate(-45 20.6369 13.4595)",
    fill: "#0086FF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2267,
    cy: 17.0483,
    r: 1.90324,
    transform: "rotate(-45 24.2267 17.0483)",
    fill: "#0086FF"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8127,
    cy: 20.6372,
    r: 1.90324,
    transform: "rotate(-45 27.8127 20.6372)",
    fill: "#0086FF"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0471,
    cy: 2.69336,
    r: 1.90324,
    transform: "rotate(-45 17.0471 2.69336)",
    fill: "#0086FF"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6369,
    cy: 6.28223,
    r: 1.90324,
    transform: "rotate(-45 20.6369 6.28223)",
    fill: "#0086FF"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.2228,
    cy: 9.87061,
    r: 1.90324,
    transform: "rotate(-45 24.2228 9.87061)",
    fill: "#0086FF"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.8127,
    cy: 13.4595,
    r: 1.90324,
    transform: "rotate(-45 27.8127 13.4595)",
    fill: "#0086FF"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.4025,
    cy: 17.0483,
    r: 1.90324,
    transform: "rotate(-45 31.4025 17.0483)",
    fill: "#0086FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.1367,
    y: 17.2192,
    width: 24.1077,
    height: 24.1077,
    transform: "rotate(-45 37.1367 17.2192)",
    fill: "#BDE0FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3242,
    y: 17.2192,
    width: 24.1077,
    height: 24.1077,
    transform: "rotate(-45 41.3242 17.2192)",
    fill: "#80BCF2",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 78.125,
    y: 17.2197,
    width: 24.1077,
    height: 24.1077,
    rx: 3,
    transform: "rotate(-45 78.125 17.2197)",
    fill: "#0086FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.0a305593fde14aa0cc39f4a2c3a03755.svg";
export { ForwardRef as ReactComponent };